<template>
  <main>
    <Alert />
    <TodaySection :today="todaysData" />
    <div style="max-width: 960px; margin: 0 auto; padding: 16px;">
      <a
        href="https://flyiisi.com/?utm_source=islamic-salahs&utm_medium=banner&utm_campaign=islamic-salahs"
        target="_blank"
      >
        <img
          class="img-fluid rounded-5"
          src="./../assets/Book_flight_with_flyiisi.gif"
          alt="Cheap flights with flyiisi.com"
        />
      </a>
    </div>
    <NextweekSection :nextweek="nextWeekData" />
    <div style="max-width: 960px; margin: 20px auto 0 auto; padding: 16px;">
      <a
        href="https://flyiisi.com/?utm_source=islamic-salahs&utm_medium=banner&utm_campaign=islamic-salahs"
        target="_blank"
      >
        <img
          class="img-fluid rounded-5"
          src="./../assets/Book_flight_with_flyiisi.gif"
          alt="Cheap flights with flyiisi.com"
        />
      </a>
    </div>
    <MonthlySection :monthly="monthlyFirstDay" />
    <div style="max-width: 960px; margin: 35px auto 0 auto; padding: 16px;">
      <a
        href="https://flyiisi.com/?utm_source=islamic-salahs&utm_medium=banner&utm_campaign=islamic-salahs"
        target="_blank"
      >
        <img
          class="img-fluid rounded-5"
          src="./../assets/Book_flight_with_flyiisi.gif"
          alt="Cheap flights with cashback"
        />
      </a>
    </div>
  </main>
</template>
<script>
import GetTimeTable from "./../data";
import TodaySection from "./mainsections/TodaySection";
import NextweekSection from "./mainsections/NextweekSection";
import MonthlySection from "./mainsections/MonthlySection";
import { addDays, daysOfWeek, monthNames } from "./../helpers";
import Alert from "./Alert";
export default {
  data() {
    return {
      date: null,
      day: null,
      month: null,
      todaysData: null,
      nextWeekData: [],
      monthlyFirstDay: [],
    };
  },
  created() {
    const getTimeTable = new GetTimeTable();
    this.date = new Date();
    this.day = new Date().getDate();
    this.month = new Date().getMonth() + 1;
    this.todaysData = getTimeTable.getByDay(this.day, this.month);

    //Next week salaahs
    for (let i = 1; i <= 10; i++) {
      let currentDate = addDays(this.date, i);
      let currentSalah = getTimeTable.getByDay(
        currentDate.getDate(),
        currentDate.getMonth() + 1
      );
      let nextDate = currentDate.getDate() + "." + (currentDate.getMonth() + 1);
      let nextDay = daysOfWeek[currentDate.getDay()];
      let hijri = new Intl.DateTimeFormat("en-TN-u-ca-islamic", {
        day: "numeric",
        month: "long",
        weekday: "long",
        year: "numeric",
      });
      let currentHijri = hijri.format(currentDate);
      let hijriStart = currentHijri.lastIndexOf(",") - 2;
      let currentHijriDay = currentHijri.substr(hijriStart, 2).trim();
      let make_obj = { ...currentSalah, nextDate, nextDay, currentHijriDay };
      this.nextWeekData.push(make_obj);
    }

    //Monthly first day data
    for (let i = 1; i <= 12; i++) {
      let firstDay = getTimeTable.getByDay(1, i);
      this.monthlyFirstDay.push({ ...firstDay, name: monthNames[i - 1] });
    }
  },
  components: {
    TodaySection,
    NextweekSection,
    MonthlySection,
    Alert,
  },
};
</script>
